module.exports = __webpack_public_path__ + "img/faleConosco.102f1c70.jpg";